import type { ReactNode } from "react";

import { toast, Zoom, type ToastOptions } from "react-toastify";

import GlobalNotification, {
  type IGlobalNotificationProps,
} from "@/components/ui/notification/GlobalNotification";

const DEFAULT_AUTO_CLOSE = 3000;

const NOTIFICATION_DEFAULT_OPTIONS: ToastOptions = {
  autoClose: DEFAULT_AUTO_CLOSE,
  className: "p-0",
  transition: Zoom,
  position: "bottom-center",
  closeButton: false,
  hideProgressBar: true,
};

export interface INotifyParams {
  msg: ReactNode | undefined;
  delay?: number;
  icon?: ReactNode;
  isAutoClose?: boolean;
}

export const notify = (
  type: IGlobalNotificationProps["type"],
  { msg, delay, icon, isAutoClose = true }: INotifyParams
) => {
  if (!msg) {
    return;
  }

  const toastId = `${type}-${String(msg)}`;
  const persistentToastId = `${toastId}-persistent`;

  if (!isAutoClose && toast.isActive(toastId)) {
    toast.dismiss(toastId);
  }

  const options: ToastOptions = {
    ...NOTIFICATION_DEFAULT_OPTIONS,
    autoClose: isAutoClose ? (delay ?? DEFAULT_AUTO_CLOSE) : false,
    toastId: isAutoClose ? toastId : persistentToastId,
  };

  toast(
    ({ closeToast }) =>
      GlobalNotification({
        type,
        message: msg,
        closeToast,
        customIcon: icon,
      }),
    options
  );
};
